import Header from '../components/Header';
import Footer from '../components/Footer';
import About from '../components/About';
import Guides from '../components/Guides';
import FAQ from '../components/FAQ';
import News from '../components/News';
import Contact from '../components/Contact';
import { ExternalLink, Star, Sparkles } from 'lucide-react';

const SlotsPage = () => {
  // Offers reordered for slots players - Magic Red first (50 spins), All British Casino (cashback), Casino Casino
  const slotsOffers = [
    {
      id: 2,
      name: 'Magic Red',
      url: 'https://www.magicred.com',
      bonus: '100% up to £35 + 50 spins',
      icon: Star,
      color: 'from-red-600 to-red-800',
      description: 'Get matched funds plus 50 free spins on premium slots. Perfect for players who want both cash and action.',
    },
    {
      id: 3,
      name: 'All British Casino',
      url: 'https://www.allbritishcasino.com/',
      bonus: 'Get 100% up to £100 + always 10% cashback',
      icon: Sparkles,
      color: 'from-purple-600 to-purple-800',
      description: 'Not just a welcome bonus – enjoy ongoing 10% cashback on every bet. The gift that keeps on giving.',
    },
    {
      id: 1,
      name: 'Casino Casino',
      url: 'https://www.casinocasino.com',
      bonus: '100% Bonus up to £100',
      icon: Star,
      color: 'from-blue-600 to-blue-800',
      description: 'Double your first deposit instantly and kickstart your winning journey with this generous welcome package.',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section for Slots */}
      <section className="relative bg-gradient-to-br from-gray-dark via-gray-medium to-gray-dark text-white py-20 md:py-32 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div 
            className="w-full h-full bg-cover bg-center"
            style={{ backgroundImage: 'url(/images/krissia-cruz-FwPzGn59wNs-unsplash.webp)' }}
          ></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl">
            <div className="flex items-center space-x-2 mb-4">
              <Sparkles className="text-yellow-accent" size={24} />
              <span className="text-yellow-accent font-semibold">Best Slots Casinos</span>
            </div>
            
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              Top UK Slots Casinos
              <span className="text-yellow-accent block">Spin & Win</span>
            </h1>
            
            <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed">
              Discover the best slots casinos in the UK. We've tested thousands of games, 
              verified every bonus, and found the operators that deliver the most exciting 
              slot experiences. From classic fruit machines to modern video slots, find your 
              perfect match and start spinning today.
            </p>
          </div>
        </div>
      </section>

      {/* Slots Offers Section */}
      <section id="offers" className="py-16 md:py-24 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-dark mb-4">
              Best Slots Casino Offers
            </h2>
            <p className="text-lg text-gray-light max-w-2xl mx-auto">
              Handpicked bonuses from UK's top slots casinos. Free spins, matched deposits, 
              and cashback rewards designed for slot enthusiasts. Each offer verified, each 
              bonus ready to claim. Your next big spin starts here.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {slotsOffers.map((offer, index) => {
              const Icon = offer.icon;
              const isEven = index % 2 === 0;
              
              return (
                <div
                  key={offer.id}
                  className={`bg-white rounded-xl shadow-lg overflow-hidden transition-all transform hover:scale-105 hover:shadow-2xl ${
                    isEven ? 'border-t-4 border-yellow-accent' : 'border-t-4 border-gray-medium'
                  }`}
                >
                  <div className={`bg-gradient-to-r ${offer.color} p-6 text-white`}>
                    <div className="flex items-center justify-between mb-4">
                      <Icon size={32} className="text-yellow-accent" />
                      <span className="bg-yellow-accent text-gray-dark px-3 py-1 rounded-full text-sm font-bold">
                        EXCLUSIVE
                      </span>
                    </div>
                    <h3 className="text-2xl font-bold mb-2">{offer.name}</h3>
                    <p className="text-gray-200 text-sm">{offer.description}</p>
                  </div>
                  
                  <div className="p-6">
                    <div className="mb-6">
                      <p className="text-sm text-gray-light mb-2">Welcome Bonus</p>
                      <p className="text-2xl font-bold text-gray-dark">{offer.bonus}</p>
                    </div>
                    
                    <a
                      href={offer.url}
                      target="_blank"
                      rel="noopener noreferrer nofollow sponsored"
                      className="w-full bg-yellow-accent text-gray-dark py-3 px-6 rounded-lg font-bold hover:bg-yellow-light transition-colors flex items-center justify-center space-x-2"
                    >
                      <span>Claim at {offer.name}</span>
                      <ExternalLink size={18} />
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <About />
      <Guides />
      <FAQ />
      <News />
      <Contact />
      <Footer />
    </div>
  );
};

export default SlotsPage;

